import React from 'react';
import { MagazineContextProvider } from '@/contexts/Magazine/Magazine.context';
import Button from '../../Button/Button';
import { ButtonColor } from '../../Button/consts';
import { ClickableAction } from '../../Clickable/consts';
import type { MagazinePrintTeaserProps } from './interfaces';
import styles from './MagazinePrintTeaser.module.scss';

const MagazinePrintTeaser = ({
  category,
  headline,
  image,
  text,
  buttonText,
  buttonLink,
}: MagazinePrintTeaserProps) => {
  const MagazineProviderWrapper = ({
    children,
    category,
  }: {
    children: React.ReactNode;
    category?: string;
  }) =>
    category ? (
      <MagazineContextProvider value={{ currentCategory: category ?? '' }}>
        {children}
      </MagazineContextProvider>
    ) : (
      <>{children}</>
    );

  return (
    <MagazineProviderWrapper category={category}>
      <div>
        <div className={styles.base}>
          <img src={image.path} alt={image.name} className={styles.image} />
          <div className={styles.content}>
            <span className={styles.headline}>{headline}</span>
            <p className={styles.text}>{text}</p>
            <Button
              actionType={ClickableAction.Linkextern}
              linkextern={buttonLink}
              color={ButtonColor.Secondary}
              className={styles.button}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </div>
    </MagazineProviderWrapper>
  );
};

export default MagazinePrintTeaser;
